import React from "react";
import {
    IoAddOutline,
    IoArrowBack,
    IoCheckmarkOutline,
    IoChevronBackOutline,
    IoChevronDownOutline,
    IoCloseOutline,
    IoCloudDownloadOutline,
    IoCreateOutline,
    IoDocumentAttachOutline,
    IoEllipsisHorizontal,
    IoEyeOutline,
    IoPaperPlaneOutline,
    IoPrintOutline,
    IoSaveOutline,
    IoSearchOutline,
    IoTrashOutline,
} from "react-icons/io5";

/**
 * Единый реестр иконок.
 *
 * Вместо того чтобы копировать inline-SVG по файлам (сегодня edit — 17 копий,
 * back — 18, print — 14), используйте семантическое имя:
 *
 *   <Icon name="print" />
 *
 * Поддерживается любой проп react-icons (size, color, className, aria-*).
 */
export const ICONS = {
    add: IoAddOutline,
    back: IoArrowBack,
    cancel: IoCloseOutline,
    check: IoCheckmarkOutline,
    chevronBack: IoChevronBackOutline,
    chevronDown: IoChevronDownOutline,
    close: IoCloseOutline,
    edit: IoCreateOutline,
    more: IoEllipsisHorizontal,
    print: IoPrintOutline,
    save: IoSaveOutline,
    search: IoSearchOutline,
    trash: IoTrashOutline,
    download: IoCloudDownloadOutline,
    view: IoEyeOutline,
    attach: IoDocumentAttachOutline,
    send: IoPaperPlaneOutline,
};

const Icon = ({ name, size, title, ...rest }) => {
    const Component = ICONS[name];
    if (!Component) return null;

    return (
        <Component
            aria-hidden={title ? undefined : true}
            aria-label={title}
            focusable="false"
            role={title ? "img" : undefined}
            size={size}
            {...rest}
        />
    );
};

export default Icon;
